<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('newsletterCard.titleNews')" class="text-left">
              <News v-if="isTitleNews" :isTitleNews="isTitleNews" :hasAlert="hasNewFiles"></News>
            </v-tab>
            <v-tab :title="$t('newsletterCard.titleMonthlyInfo')" class="text-left">
              <MonthlyInfo v-if="isTitleMonthlyInfo" :isTitleMonthlyInfo="isTitleMonthlyInfo"></MonthlyInfo>
            </v-tab>
            <v-tab :title="$t('newsletterCard.titleVideoSupport')" class="text-left">
              <VideoSupport v-if="isTitleVideoSupport" :isTitleVideoSupport="isTitleVideoSupport"></VideoSupport>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import News from 'src/components/Dashboard/Views/Newsletter/Tabs/News.vue'
  import MonthlyInfo from 'src/components/Dashboard/Views/Newsletter/Tabs/MonthlyInfo.vue'
  import VideoSupport from 'src/components/Dashboard/Views/Newsletter/Tabs/VideoSupport.vue'

  export default {
    components: {
      News,
      MonthlyInfo,
      VideoSupport
    },
    data () {
      return {
        isTitleNews: false,
        isTitleMonthlyInfo: false,
        isTitleVideoSupport: false,
        hasNewFiles: false
      }
    },
    mounted () {
      this.switchTab()
    },
    created () {
      this.fetchNews()
    },
    methods: {
      resetStates () {
        this.isTitleNews = false
        this.isTitleMonthlyInfo = false
        this.isTitleVideoSupport = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('newsletterCard.titleNews'):
            this.isTitleNews = true
            break
          case this.$t('newsletterCard.titleMonthlyInfo'):
            this.isTitleMonthlyInfo = true
            break
          case this.$t('newsletterCard.titleVideoSupport'):
            this.isTitleVideoSupport = true
            break
          default:
            this.isTitleNews = true
            break
        }
      },
      async fetchNews () {
        try {
          let data = {
            token: this.$session.get('token')
          }
          this.apiRequest('/pdf-files/new', 'GET', data, (response) => {
            if (response.status === true) {
              this.hasNewFiles = response.data
            }
          })
        } catch (error) {
          console.error('Error fetching new files status (Catch):', error.response)
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Newsletter/NewsletterSidebar.vue